<template>
  <div id="app-container">
    <!-- 顶部导航栏 - 仅登录页显示 -->
    <TopNav v-show="isLoginPage" />
    
    <!-- 主内容区域 -->
    <main id="app-main">
      <HomePage />
    </main>
    
    <!-- 底部导航栏 - 仅登录页显示 -->
    <Footer v-show="isLoginPage" />
    
    <!-- 侧边悬浮窗 - 仅登录页显示 -->
    <Suspension v-show="isLoginPage" />
  </div>
</template>

<script>
import HomePage from "@/views/HomePage.vue";
import TopNav from "@/components/header/TopNav.vue";
import Footer from "@/components/footer/Footer.vue";
import Suspension from "@/components/suspension/Suspension.vue";

export default {
  name: "app",
  components: {
    HomePage,
    TopNav,
    Footer,
    Suspension
  },
  computed: {
    isLoginPage() {
      return this.$route.name === 'Login';
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  width: 100%;
  min-height: 100vh;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #efeff3;
}

#app-main {
  flex: 1;
  padding-top: 0;
}
</style>